import { render } from "./SongSectionsTab.vue?vue&type=template&id=13067b01"
import script from "./SongSectionsTab.vue?vue&type=script&lang=js"
export * from "./SongSectionsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__